import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB-hbRGxdYhWAXdo7MtMYGnzRsAxhryfqI",
  authDomain: "spring-and-co.firebaseapp.com",
  projectId: "spring-and-co",
  storageBucket: "spring-and-co.firebasestorage.app",
  messagingSenderId: "846833385316",
  appId: "1:846833385316:web:d1beeda04bb30b46a98471",
  measurementId: "G-6GP7W5TL1K"
};

// Initialise Firebase
const app = initializeApp(firebaseConfig);

// Services
export const auth = getAuth(app);
export const db = getFirestore(app);